import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import { useCustomerTenantRemoveMutation } from "@/v2-backoffice-client/customer/tenant/remove/customer.tenant.remove.mutation"

export type CustomerTenantRemoveMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  customerId: number
  tenantId: number
  customerName?: string
  tenantName?: string
  onCompleted?(): void
}

function CustomerTenantRemoveMenuItem(
  props: CustomerTenantRemoveMenuItemProps,
) {
  const {
    customerId,
    tenantId,
    customerName,
    tenantName,
    onCompleted,
    ...menuItemProps
  } = props

  const [removeTenant, { loading, error }] = useCustomerTenantRemoveMutation({
    onCompleted,
  })

  return (
    <ActionMenu.ConfirmItem
      iconSrc="trash"
      variant="destructive"
      isLoading={loading}
      error={error}
      errorTitle="Failed to remove team from customer"
      confirmTitle="Remove from Customer"
      confirmDescription={
        tenantName && customerName
          ? `Are you sure you want to remove ${tenantName} from ${customerName}?`
          : "Are you sure you want to remove this team from the customer?"
      }
      confirmText="Remove"
      confirmVariant="destructive"
      onConfirm={async () => {
        await removeTenant({ variables: { customerId, tenantId } })
      }}
      {...menuItemProps}
    >
      Remove from Customer
    </ActionMenu.ConfirmItem>
  )
}

export default CustomerTenantRemoveMenuItem
